"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateExpiry = exports.setApiKey = exports.onExpirySavedToStorage = exports.getExpiryFromStorage = exports.getApiKeyManager = exports.generateExpiry = exports.encryptAndSaveExpiry = exports.createKeyFromExpiry = void 0;
var _dayjs = _interopRequireDefault(require("dayjs"));
var _keyEncryption = require("./keyEncryption");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var API_EXP_STORAGE_KEY = 'api:exp';
var apiKey = '';
var setApiKey = exports.setApiKey = function setApiKey(newKey) {
  apiKey = newKey;
};
var getApiKey = function getApiKey() {
  return apiKey;
};
var generateExpiry = exports.generateExpiry = function generateExpiry() {
  var now = new Date();
  var start = (0, _dayjs["default"])(now);
  var end = (0, _dayjs["default"])(now).add(process.env.API_EXP_DURATION_IN_SECOND, 'seconds');
  return "".concat(start.valueOf().toString(), ":").concat(end.valueOf().toString());
};
var onExpirySavedToStorage = exports.onExpirySavedToStorage = function onExpirySavedToStorage(apiKey, clientId) {
  return function (value) {
    var expiry = _keyEncryption.cryptoService.decrypt(value);
    if (!validateExpiry(expiry)) {
      return;
    }
    setApiKey(createKeyFromExpiry(apiKey, clientId)(expiry));
  };
};
var encryptAndSaveExpiry = exports.encryptAndSaveExpiry = function encryptAndSaveExpiry(apiKey, clientId) {
  return function (expiry) {
    var result = _keyEncryption.cryptoService.encrypt(expiry);
    var encryptedExpiry = result["int"];
    sessionStorage.setItem(API_EXP_STORAGE_KEY, encryptedExpiry);
    onExpirySavedToStorage(apiKey, clientId)(encryptedExpiry);
    return encryptedExpiry;
  };
};
var getExpiryFromStorage = exports.getExpiryFromStorage = function getExpiryFromStorage() {
  var _sessionStorage;
  return (_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.getItem(API_EXP_STORAGE_KEY);
};
var validateExpiry = exports.validateExpiry = function validateExpiry(expiry) {
  var apiExpiry = expiry;
  if (!apiExpiry || apiExpiry.indexOf(':') < 0 || apiExpiry.split(':').length !== 2) {
    return false;
  }
  var startTimestamp = Number(apiExpiry.split(':')[0]);
  var endTimestamp = Number(apiExpiry.split(':')[1]);
  if (startTimestamp >= endTimestamp) {
    return false;
  }
  return (0, _dayjs["default"])().isBefore((0, _dayjs["default"])(endTimestamp));
};
var createKeyFromExpiry = exports.createKeyFromExpiry = function createKeyFromExpiry(apiKey, clientId) {
  return function (expiry) {
    var textToEncrypt = "".concat(apiKey, ":").concat(expiry, ":").concat(clientId);
    var encryptedText = _keyEncryption.cryptoService.rsaEncrypt(textToEncrypt);
    return encryptedText;
  };
};
var resetExpiry = function resetExpiry(apiKey, clientId) {
  return function () {
    var newExpiry = generateExpiry();
    encryptAndSaveExpiry(apiKey, clientId)(newExpiry);
  };
};
var isAuthenticated = function isAuthenticated(apiKey, clientId) {
  return function () {
    var rawExpiry = getExpiryFromStorage();
    if (!rawExpiry) {
      return false;
    }
    var expiry = _keyEncryption.cryptoService.decrypt(rawExpiry);
    if (validateExpiry(expiry)) {
      var key = createKeyFromExpiry(apiKey, clientId)(expiry);
      setApiKey(key);
    }
    return validateExpiry(expiry) && getApiKey() !== '';
  };
};
var getApiKeyManager = exports.getApiKeyManager = function getApiKeyManager(apiKey, clientId) {
  return {
    getApiKey: getApiKey,
    isAuthenticated: isAuthenticated(apiKey, clientId),
    resetApiKeyExpiry: resetExpiry(apiKey, clientId)
  };
};